<template>
    <div class="my-profile">
        <div style="background: #f7f7f7">
            <navbar></navbar>
        </div>
        <div class="container">
            <div
                class="font-apercu-bold is-size-4"
                style="margin-bottom: 60px; display: flex"
            >
                <h2 class="title">{{ $t("My personal information") }}</h2>
            </div>

            <div class="contents">
                <div class="content">
                    <div class="info" v-if="user.is_store">
                        <div class="sec_title">
                            <p class="title">{{ $t("Store name") }}</p>
                            <button
                                class="button"
                                :disabled="editSection && editSection != 1"
                                @click="toggleEdit(1)"
                            >
                                {{
                                    editSection == 1 ? $t("Cancel") : $t("Edit")
                                }}
                            </button>
                        </div>
                        <div class="inputs" v-show="editSection != 1">
                            <h6>
                                {{
                                    user.store_name
                                        ? user.store_name
                                        : $t("Not defined before")
                                }}
                            </h6>
                        </div>
                        <div class="inputs" v-show="editSection == 1">
                            <div class="item" style="width: 60%">
                                <p style="margin-bottom: 12px">
                                    {{ $t("Store name") }}
                                </p>
                                <input
                                    type="text"
                                    :class="{ danger: errors.length }"
                                    v-model="store_name"
                                    :placeholder="$t('Store name')"
                                />
                                <p
                                    class="error"
                                    v-show="errors.includes('store_name')"
                                >
                                    {{ $t("Required") }}
                                </p>
                            </div>
                            <div>
                                <loading v-show="loading" />
                                <button
                                    v-show="!loading"
                                    :disabled="loading"
                                    @click="update('store_name')"
                                    class="button"
                                >
                                    {{ $t("Save") }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="info">
                        <div class="sec_title">
                            <p class="title">{{ $t("Name") }}</p>
                            <button
                                class="button"
                                :disabled="editSection && editSection != 2"
                                @click="toggleEdit(2)"
                            >
                                {{
                                    editSection == 2 ? $t("Cancel") : $t("Edit")
                                }}
                            </button>
                        </div>
                        <div class="inputs" v-show="editSection != 2">
                            <h6>
                                {{ user.first_name + " " + user.last_name }}
                            </h6>
                        </div>
                        <div class="inputs" v-show="editSection == 2">
                            <div class="item">
                                <p style="margin-bottom: 12px">
                                    {{ $t("First name") }}
                                </p>
                                <input
                                    type="text"
                                    :class="{ danger: errors.length }"
                                    v-model="first_name"
                                    placeholder="name"
                                />
                                <p
                                    class="error"
                                    v-show="errors.includes('first_name')"
                                >
                                    {{ $t("Required") }}
                                </p>
                            </div>
                            <div class="item">
                                <p style="margin-bottom: 12px">
                                    {{ $t("Last name") }}
                                </p>
                                <input
                                    type="text"
                                    :class="{ danger: errors.length }"
                                    v-model="last_name"
                                    placeholder="name"
                                />
                                <p
                                    class="error"
                                    v-show="errors.includes('last_name')"
                                >
                                    {{ $t("Required") }}
                                </p>
                            </div>
                            <div>
                                <loading v-show="loading" />
                                <button
                                    v-show="!loading"
                                    :disabled="loading"
                                    @click="update('first_name', 'last_name')"
                                    class="button"
                                >
                                    {{ $t("Save") }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="info">
                        <div class="sec_title">
                            <p class="title">{{ $t("Phone Number") }}</p>
                            <button
                                class="button"
                                :disabled="editSection && editSection != 3"
                                @click="toggleEdit(3)"
                            >
                                {{
                                    editSection == 3 ? $t("Cancel") : $t("Edit")
                                }}
                            </button>
                        </div>
                        <div class="inputs" v-show="editSection != 3">
                            <h6 style="direction: ltr">
                                {{
                                    "+" +
                                    user.country_code +
                                    " " +
                                    user.abstract_mobile
                                }}
                            </h6>
                        </div>
                        <div class="inputs" v-show="editSection == 3">
                            <div style="display: flex; width: 70%">
                                <div class="item" style="width: 80%">
                                    <p style="margin-bottom: 12px">
                                        {{ $t("Phone Number") }}
                                    </p>
                                    <input
                                        class="phone"
                                        type="number"
                                        v-model="mobile"
                                        :placeholder="$t('Phone Number')"
                                    />
                                    <p
                                        class="error"
                                        v-show="errors.includes('mobile')"
                                    >
                                        {{ $t("Required") }}
                                    </p>
                                </div>
                                <div
                                    class="item"
                                    style="
                                        width: 20%;
                                        align-self: center;
                                        margin-top: 7px;
                                    "
                                >
                                    <p>{{ $t("Code") }}</p>
                                    <basic-select
                                        :placeholder="$t('Code')"
                                        :options="code"
                                        @value="areaCode = $event"
                                        :currValue="areaCode"
                                        ref="code"
                                    ></basic-select>
                                </div>
                            </div>

                            <div>
                                <loading v-show="loading" />
                                <button
                                    v-show="!loading"
                                    :disabled="loading"
                                    @click="update('mobile', 'areaCode')"
                                    class="button"
                                >
                                    {{ $t("Save") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="image">
                    <input
                        type="file"
                        @change="uploadImage($event)"
                        style="display: none"
                        ref="image"
                    />
                    <div class="img" @click="$refs.image.click()">
                        <img v-show="!loading" :src="user.user_image" alt="" />
                        <loading v-show="loading" />
                        <div class="layer" v-if="!loading">
                            <span>Upload image</span>
                        </div>
                    </div>
                    <div
                        class="error"
                        style="
                            margin-top: 20px;
                            font-weight: bold;
                            background: #eee;
                            border-radius: 7px;
                            padding: 10px;
                        "
                        v-if="errors.includes('image')"
                    >
                        {{ $t("Please upload a file of type: Jpg, png, jpeg") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "@/components/Loading";
import BasicSelect from "@/components/ccSelect.vue";
import Navbar from "@/components/Nav/Navbar.vue";
export default {
    data() {
        return {
            first_name: null,
            last_name: null,
            mobile: null,
            editSection: null,
            areaCode: null,
            store_name: null,
            errors: [],
            loading: false,
        };
    },
    computed: {
        user() {
            return this.$store.getters.userData;
        },
        code() {
            let c = this.$store.state.countries;
            let codes = [];
            c.forEach((x) => {
                codes.push({
                    ext: x.phone_code,
                    iso: x.iso,
                });
            });
            return codes;
        },
    },
    watch: {
        user: {
            immediate: true,
            handler(val) {
                this.resetForm(val);
            },
        },
    },
    methods: {
        resetForm(val) {
            this.first_name = val.first_name;
            this.last_name = val.last_name;
            this.areaCode = Number(val.country_code);
            this.mobile = val.abstract_mobile;
            this.store_name = val.store_name;
        },
        toggleEdit(num) {
            this.errors = [];
            this.resetForm(this.user);
            if (this.editSection == num) return (this.editSection = null);
            this.editSection = num;
        },
        uploadImage(e) {
            this.errors = [];
            let data = new FormData();
            data.append("avatar", e.target.files[0]);
            this.loading = true;
            this.$store
                .dispatch("UPLOADE_AVATAR", data)
                .then((res) => {
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    this.erros.push("image");
                });
        },
        update(...arg) {
            this.errors = [];
            let reqBody = arg.reduce((obj, key) => {
                if (!this[key]) this.errors.push(key);
                obj[key] = this[key];
                return obj;
            }, {});
            if (this.errors.length) return;
            this.loading = true;

            this.$store
                .dispatch("UPDATE_USER_PROP", reqBody)
                .then((res) => {
                    this.editSection = null;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
    },
    components: {
        Navbar,
        BasicSelect,
        Loading,
    },
    mounted() {
        this.$store.dispatch("countries");
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .mx-datepicker {
        width: 100%;

        .mx-input {
            border: none !important;
            border-bottom: 1px solid #ddd !important;
            border-radius: 0 !important;
            box-shadow: none !important;
        }
    }
}

.error {
    color: #ff7977 !important;
    font-size: 14px;
    margin: 0 10px;
    position: absolute;
}

.my-profile {
    background: white;
    min-height: 100vh;

    select {
        border: none;
        border-bottom: 1px solid #ddd;
        width: 100%;
        height: 40px;
        font-size: 18px;
        padding: 0 20px;

        &:active,
        &:focus {
            outline: none;
        }
    }

    .phone {
        direction: ltr;
        letter-spacing: 4px;
        padding-bottom: 2px;

        border-bottom: 2px solid #ddd;
    }

    .sec_title {
        width: 85%;
        display: flex;
        justify-content: space-between;

        .title {
            margin-bottom: 5px;
            font-size: 20px;
        }

        .button {
            border: none;
            outline: none !important;
            font-weight: bold;
            font-size: 18px;
            color: #777;
            text-decoration: underline;

            &:active {
                outline: none;
            }

            &:focus {
                outline: none;
            }
        }
    }

    .container {
        padding: 20px 0;
        margin: 0 40px;

        .contents {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .image {
                width: 25%;
                text-align: center;

                .img {
                    position: relative;
                    width: 300px;
                    height: 300px;
                    overflow: hidden !important;
                    transition: 0.4s;
                    background: rgba(63, 80, 162, 0.8);
                    border-radius: 20px;

                    img {
                        border-radius: 20px;
                        cursor: pointer;
                        position: absolute;
                        z-index: 1;
                    }

                    .layer {
                        cursor: pointer;
                        height: 100%;
                        left: 0;
                        right: 0;
                        position: absolute;
                        background: rgba(63, 80, 162, 0);
                        color: #ffffff50;
                        display: flex;
                        opacity: 1;
                        align-items: flex-end;
                        justify-content: center;
                        font-size: 25px;
                        z-index: 2;
                        border-radius: 20px;
                        transition: 0.4s;
                    }

                    &:hover {
                        .layer {
                            background: rgba(63, 80, 162, 0.6);
                            color: #ffffff;
                        }
                    }
                }
            }

            .content {
                width: 65%;

                .info {
                    padding: 20px 35px;
                    margin: 0 10px;
                    border-bottom: 3px solid #eee;

                    &:last-of-type {
                        border: none;
                    }

                    .inputs {
                        width: 85%;
                        display: flex;
                        align-items: flex-end;
                        justify-content: space-between;

                        padding: 10px 0 40px;
                        margin: 5px;

                        h6 {
                            font-size: 18px;
                            color: #777;
                            margin: 0;
                        }

                        .item {
                            width: 45%;

                            p {
                                margin-bottom: 5px;
                                color: #777;
                            }

                            input {
                                width: 85%;
                                border-bottom: 1px solid #ddd;
                                font-size: 16px;
                                padding: 10px;
                                margin-bottom: 5px;

                                &.danger {
                                    border-color: #ff7977 !important;

                                    &::placeholder {
                                        color: red;
                                    }
                                }
                            }
                        }

                        .button {
                            padding: 5px 30px;
                            background: #4952ff !important;
                            color: white;
                        }
                    }
                }
            }
        }
    }
}
</style>
